module.exports = __webpack_public_path__ + "img/image-our-story-academy-template-p-800.bcac29c4.jpeg";